<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-color-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                          [label]="label" [labelI18NParams]="labelI18NParams" [placeholder]="placeholder"
                          (focussed$)="onFocussed($event)" *ngSwitchDefault [notation]="notation"
                          [allowAlpha]="allowAlpha" [textColor]="textColor"
                          [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                          [okLabel]="okLabel" [resetLabel]="resetLabel"></fui-edit-color-input>
    <fui-inline-color-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                            (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE" [notation]="notation"
                            [placeholder]="placeholder" [allowAlpha]="allowAlpha" [textColor]="textColor"
                            [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                            [okLabel]="okLabel" [resetLabel]="resetLabel"></fui-inline-color-input>
</ng-container>
